import React, { Fragment } from 'react';
import { Translate } from 'core/translate';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalFooterButtons,
  ModalFooterCancelButton,
  ModalFooterPrimaryButton
} from '../../common/modal/Modal';
import ModalImage from '../../common/modal/ModalImage';

const getHeader = ({ displayName, description, primaryName }) =>
  displayName || description || primaryName;

const getDescription = option => {
  const { longCFD, extendedCFD } = option;
  const header = getHeader(option);

  if (header === longCFD && extendedCFD) {
    return header + extendedCFD;
  }

  return longCFD || extendedCFD;
};

const getButtons = ({ option, onSelect, onClose }) => {
  const { selected, removable, includedInPackage } = option;
  const unremovable = selected && !removable && !includedInPackage;
  const header = getHeader(option);

  if (unremovable) {
    return <ModalFooterPrimaryButton onClick={onClose} data-dtm={header} />;
  }

  return (
    <Fragment>
      <ModalFooterCancelButton onClick={onClose} data-dtm={header} />
      <ModalFooterPrimaryButton onClick={onSelect} data-dtm={header}>
        <Translate
          value={selected ? 'remove.option' : 'byo.page.general.select'}
        />
      </ModalFooterPrimaryButton>
    </Fragment>
  );
};

const OptionDetailsInner = ({ option }) => {
  const { largeImageUrl, shortCFD, displayedMsrp, disclaimer, msrp } = option;
  const description = getDescription(option);

  const msrpContainer = msrp ? (
    <div className="price modal__price modal-body__label">{displayedMsrp}</div>
  ) : null;

  return (
    <div className="modal-body__content">
      <ModalImage alt={shortCFD} url={largeImageUrl} />

      <div className="modal-body__description-container">
        {msrpContainer}
        <div dangerouslySetInnerHTML={{ __html: description }} />
        <div
          dangerouslySetInnerHTML={{ __html: disclaimer }}
          className="modal__disclaimer"
        />
      </div>
    </div>
  );
};

const OptionDetails = ({ option, onSelect, onClose }) => {
  const header = getHeader(option);

  return (
    <Modal isOpen={true} contentLabel={header} onRequestClose={onClose}>
      <ModalHeader text={header} analyticsKey={header} onClose={onClose} />
      <ModalBody>
        <OptionDetailsInner option={option} />
      </ModalBody>
      <ModalFooter>
        <ModalFooterButtons>
          {getButtons({ option, onSelect, onClose })}
        </ModalFooterButtons>
      </ModalFooter>
    </Modal>
  );
};

export default OptionDetails;
